module.exports = __webpack_public_path__ + "static/media/noMap.2ca18f93.svg";